module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"partner_products":{"button":"Discover all products","description":"These products are regularly supplemented with in-depth information and updates under \\"Fund library\\"","title":"Products with fund library"}}}}}}')
  delete Component.options._Ctor
}
